import AxiosInstance from "./api";

export const AccountingStatement4Service = {
  create: (payload) => AxiosInstance.post("/private/accounting-statement-4", payload),
  sync: (payload) => AxiosInstance.post("/private/accounting-statement-4/sync", payload),
  update: (id, payload) => AxiosInstance.put(`/private/accounting-statement-4/${id}`, payload),
  delete: (id) => AxiosInstance.delete(`/private/accounting-statement-4/${id}`),
  findAll: (params) => AxiosInstance.get("/private/accounting-statement-4", { params }),
  findById: (id) => AxiosInstance.get(`/private/accounting-statement-4/${id}`),
  preview: (params) => AxiosInstance.get("/private/accounting-statement-4/sync/preview", { params }),
  findAccounts: (params) => AxiosInstance.get("/private/accounting-statement-4/accounts", { params }),
};
